import { api } from "../app/api";
import { useAsync } from "../app/useAsync";

export function MigrationJobsPage() {
  const { data, error, loading } = useAsync(api.jobs, []);
  const jobs = data?.jobs ?? [];

  return (
    <>
      <h1>Migration Jobs</h1>
      <p className="page-sub">History of migration runs. Read-only.</p>

      {loading && <p className="muted">Loading…</p>}
      {error && <p className="muted">Unavailable ({error}).</p>}

      {!loading && !error && jobs.length === 0 && (
        <div className="empty">
          No migration jobs yet. Generating previews or evaluating matches
          records a job here.
        </div>
      )}

      {jobs.length > 0 && (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Status</th>
                <th>Progress</th>
                <th>Started</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((j) => (
                <tr key={j.id}>
                  <td>{j.id}</td>
                  <td className="muted">{j.jobType ?? "—"}</td>
                  <td>{j.status}</td>
                  <td className="muted">
                    {j.processedRecords}/{j.totalRecords}
                  </td>
                  <td className="muted">{j.startedAt ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
